<template>
  <div>
    <b-row>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="NameVopProvider" isMandatory
          :inputLabel="$t('common.vop_provider.name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
          :inputLabel="$t('common.vop_provider.name')"
          :inputValue="NameVopProvider">
        </form-read-group-label-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: "VopProviderForm",
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    "form-write-group-label-input": formWriteGroupLabelInput
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    NameVopProvider: {
      get () {
        return this.inputValue.NameVopProvider
      },
      set (val) {
        this.inputValue = {
          NameVopProvider: val
        }
      }
    }
  }
}
</script>
